export const projectsData = {
    'fear-of-falling': {
      title: 'Fear of Falling',
      category: 'Short Film',
      role: 'Director of Photography / Colorist',
      director: 'Jeremy Anderson',
      producer: 'Jeremy Anderson, Lisa Frenek, Tracey Rooney, Maryna Bogdan',
      description: "A young boy's discovery of his supernatural abilities causes him an existential crisis, but also leads him on a path to adventure and love",
      imageCount: 14
    },
    'the-mental-state': {
        title: 'The Mental State',
        category: 'Narrative Feature Film',
        role: 'Director of Photography / Colorist',
        description: "In the heart of rural Kentucky, a high school senior and his family struggle to cope with the true identity and intentions of a dangerous town shooter.",
        director: 'James Camali',
        producer: 'Matthew Einstein, Glen Trotiner, and Ronnee Swenton',
        starring: (
            <>
            <a href="https://www.imdb.com/name/nm5602040/">Jance Enslin</a>, <a href="https://www.imdb.com/name/nm0005318/">Carly Pope</a>, <a href="https://www.imdb.com/name/nm1451415/">Alyssa Sutherland</a>, <a href="https://www.imdb.com/name/nm1034965/">Bryan Greenberg</a>, <a href="https://www.imdb.com/name/nm5944803/">Alison Thornton</a>
            </>
        ),
        awards: (
            <>
            <strong>Best Actor</strong> <a href="http://newportbeachfilmfest.com/">Newport Beach Film Festival</a>
            <br /><strong>Best US Feature Film, Best Director, Best Male Lead</strong> Catalina Film Festival
            <br /><strong>Best Feature Film</strong> NJIFF
            <br /><strong>Best of Fest</strong> River’s Edge International Film Festival
            <br /><strong>Best Digital Feature Film</strong> SFFF
            <br /><strong>Semifinalist</strong> Chicago Blow-Up Arthouse Film Festival
            <br /><strong>Screenplay Quarterfinalist</strong> Atlanta Film Festival
            <br /><strong>Top 50 Screenplay</strong> Cinequest
            <br /><strong>Official Selection</strong> Boston Film Festival, Mammoth Film Festival, Dallas International Film Festival, Portland Film Festival, Syracuse International Film Festival, Louisville’s International Festival of Film, NYSWI Albany Film Festival.
            </>
        ),
        imageCount: 10,
        link: 'https://www.outofshot.com/#/thementalstate/'
    },
    'apocalypse-meow': {
      title: 'Apocalypse Meow',
      category: 'Short Film',
      role: 'Director of Photography / Colorist',
      director: 'Kevin Tewksbury',
      description: "What started as a parody of Apocalypse Now but with cats, ends up as a years long adventure as a filmmaker's obsession spirals into a mental health crisis ripe with disaster and near-death.",
      imageCount: 7
    },
    'mandeep-bunny-boiler': {
        title: 'Mandeep - Bunny Boiler',
        category: 'Music Video',
        role: 'Colorist',
        producer: 'Adam R Wood',
        director: 'Mandeep Dhillon',
        video_url: 'https://www.youtube.com/embed/DZhj_XeXWt0?modestbranding=1&rel=0&iv_load_policy=3',
        imageCount: 10
    },
    'gary': {
        title: 'Gary',
        category: 'Short Film',
        role: 'Director of Photography / Colorist',
        director: 'James Camali',
        description: "As an attempt to cover up his drug dealings and make some extra cash, Mike Tambora has assumed the responsibility of caretaker for a middle-aged, mentally disabled man named Gary. After months of taking Gary to the local bowling alley, the two connect for the first time when Mike takes a stand to those who mistreat Gary. But then, Mike and Gary's future takes a turn when Mike’s botched drug deal from the past leaves the two surrounded in the parking lot.",
        awards: "Independent Filmmaker Project Award (IFP is now The Gotham)",
        imageCount: 12,
        link: 'https://www.outofshot.com/#/gary/'
    },
    'a-fatal-obsession': {
        title: 'A Fatal Obsession',
        category: 'Narrative Feature Film',
        role: 'Director of Photography / Colorist',
        director: 'James Camali',
        producer: 'Richard Switzer',
        description: "A mother and teen daughter believe they have at last found safe refuge from their abusive husband and father Michael. Michael, enraged by their escape, will do anything to find them. After undergoing drastic plastic surgery, he assumes a new unrecognizable identity, and the hunt for his family begins.",
        imageCount: 9,
        link: 'https://www.outofshot.com/#/afatalobsession/'
    },
    'elvis-rocky-and-me': {
        title: 'Elvis, Rocky, and Me',
        category: 'Documentary',
        role: 'Colorist',
        director: 'Alex Rotaru',
        starring: 'Barbi Benton, Carol Connors, Bill Conti, David Longoria, Mike Tyson',
        description: "She was Phil Spector's muse... Elvis Presley's lover... Rocky Balboa's lyricist... and the most famous Diva that you've never heard of. This feature biographical documentary of legendary, twice Academy Award-nominated, hit singer and songwriter, Carol Connors, tells the tale of her wild ride through the film and music industries. Featuring her friends Talia Shire, Bill Conti, Dionne Warwick, Irwin Winkler, Diane Warren, Mike Tyson, Barbi Benton, David Shire, and many more. Carol's story builds in unexpected ways... every moment you think her story has ended, an amazing twist takes us in another direction, proving that life beats fiction eleven times out of ten (with Carol, even THAT is possible!) A Forrest Gump and Zadig-like character, Carol finds herself in the heart of every major story at the intersection of classic Hollywood and Rock 'n' Roll, proving that if age is just a number, hers is both unlisted and irrelevant to her indefatigable and constantly successful quest for continued creative relevance.",
        imageCount: 3,
        link: 'https://www.tmz.com/2024/06/29/songwriter-carol-connors-rocky-sylvester-stallone-elvis-presley-relationship/'
    },
    'blue-line': {
        title: 'Blue Line',
        category: 'Narrative Feature Film',
        role: 'Colorist',
        director: 'Jacob Cooney',
        starring: 'Tom Sizemore, Jordan Ladd, Nikki Moore, Tom DeNucci, Kevin Nash',
        producer: 'Richard Switzer',
        description: "A woman and her best friend go on a crime spree to rob her husband and escape her marriage.",
        imageCount: 4
    },
    'the-essay-from-hell': {
        title: 'The Essay from Hell',
        category: 'Short Film',
        role: 'Director of Photography / Colorist',
        director: 'Max Seiler',
        description: "A highschool student goes too deep while researching for his latest class project and ends up summoning a demon.",
        imageCount: 6
    },
    'the-santa-clause': {
        title: 'The Santa Clause',
        category: 'Short Film',
        role: 'Director / Director of Photography / Colorist',
        description: "Santa is heartbroken by a child's letter and goes on a mission to make the girl's christmas dream come true. But in doing so he must make a great sacrifice. Grand Prize Winner of a 6 day film competition.",
        imageCount: 8,
        video_url: 'https://www.youtube.com/embed/wnlhFiy50l0?modestbranding=1&rel=0&iv_load_policy=3',
        awards: (
            <>
            <strong>Grand Prize Winner</strong> 3rd annual paymoneywubby Short Film Contest
            </>
        )
    },
    'the-getter': {
        title: 'The Getter',
        category: 'Short Film',
        role: 'Colorist',
        imageCount: 12
    },
    'to-kill-a-nazi': {
        title: 'To Kill A Nazi',
        category: 'Documentary',
        role: 'Colorist',
        director: 'Boaz Dvir',
        producer: 'Boaz Dvir, Matthew Einstein, Gayle Zachmann',
        description: "The incredible story of a Frenchman who sets out to uncover the truth about his father’s disappearance during War World II and ends up playing a crucial role in history’s most audacious hostage rescue: the Entebbe Raid. Michel Cojot discovers his father died in Auschwitz. On the arrest paper, Michel spots Gestapo Commander Klaus Barbie’s signature. He learns Barbie escaped to Bolivia. Posing as a journalist, Michel flies to La Paz to interview Barbie. He then follows Barbie through the city. Down an alley, Michel aims his pistol. He hesitates. His decision haunts him. Soon, he gets a chance for redemption.",
        imageCount: 3,
    },
    'schools-out': {
        title: "School's Out",
        category: 'Narrative Feature Film',
        role: 'Colorist',
        director: 'Jared Cohn',
        producer: 'David Seth Cohen, Jared Safier, and Richard Switzer',
        starring: 'Richard Switzer, Jackie Moore, Nick Swardson, Eric Roberts, Jason London, Kayden Kross',
        description: "Teen stepbrothers, Danny, a wannabe entrepreneur, and Ajay, an artistic dreamer, pull off an elaborate prank on the last day of school. Caught in the act, they're assigned to a summer mentor: lascivious bar owner, Tyler Lavey. When Tyler enlists the boys to make a delivery to a private party, they unwittingly stumble upon an underground society hiding some very dirty secrets. After Tyler's own niece is taken captive, he turns to proteges Danny and Ajay and former CIA agent Grandma Alice to stage one kick-ass rescue.",
        imageCount: 2
    },
    'secret-tapes-good-grief': {
        title: "Secret Tapes - Good Grief",
        category: 'Music Video',
        role: 'Director of Photography / Colorist',
        imageCount: 1
    },
    'eytan-only-got-one-night': {
        title: "Eytan - Only Got One Night",
        category: 'Music Video',
        role: 'Director of Photography / Colorist',
        imageCount: 1,
        // video_url: 'https://www.youtube.com/embed/NoO-nwdVRZQ?modestbranding=1&rel=0&iv_load_policy=3',
    },
    'eytan-after-the-rain': {
        title: "Eytan - After the Rain",
        category: 'Music Video',
        role: 'Director of Photography / Colorist',
        imageCount: 2,
        // video_url: 'https://www.youtube.com/embed/KNrklItCxKc?modestbranding=1&rel=0&iv_load_policy=3',
    },
    'super-pages-app': {
        title: "Super Pages App",
        category: 'Commercial',
        role: 'Director of Photography / Colorist',
        imageCount: 1
    },
    'these-guys-brewery': {
        title: "These Guys Brewery",
        category: 'Commercial',
        role: 'Director of Photography / Colorist',
        imageCount: 1
    },
    'dnd-next': {
        title: "D&D Next",
        category: 'Commercial',
        role: 'Director of Photography / Colorist',
        imageCount: 1
    },
}